import { useState, useEffect } from 'react';
import { connectionService, Connection, ConnectionType } from '../services/connectionService';

export function useConnections() {
  const [connections, setConnections] = useState<Connection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  const loadConnections = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await connectionService.getConnections();
      setConnections(data);
    } catch (err) {
      console.error('Failed to load connections:', err);
      setError(err instanceof Error ? err.message : 'Failed to load connections');
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    loadConnections();
  }, []);
  
  const getConnectionByType = (type: ConnectionType): Connection | undefined => {
    return connections.find(c => c.connectionType === type);
  };
  
  const deleteConnection = async (id: string) => {
    await connectionService.deleteConnection(id);
    await loadConnections();
  };
  
  return {
    connections,
    loading,
    error,
    reload: loadConnections,
    getConnectionByType,
    deleteConnection,
  };
}

